import { getItem } from '@/utility/localStorageControl'
import {ref} from 'vue'
export function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}


export function checkUserRoleAccess(permission) {
  const newPermission = getItem('permissions')
  const userProfile = getItem('user_profile')

  const userPermission  = ref([])
  const listRoleName = ref([])
  listRoleName.value = userProfile.roles?.flatMap(role => role.name)
  
  if(newPermission){
    userPermission.value = newPermission.map((data) => data.name)
  } else {
    userPermission.value = userProfile.roles?.flatMap(role => role.permissions).map((data) => data.name) || []
  }

  if (listRoleName.value.includes('Super Admin')) {
    return true
  }

  if (Array.isArray(permission) && permission.length > 0) {
    // Multi-level permission
    return permission.some((p) => userPermission.value.includes(p))
  }
  // single permission
  return userPermission.value.includes(permission)
}

